import { SelectListOption } from "./common.type";
import { VacancyStatus } from "./enums.type";

export interface VacancyApplicantDto {
  userId: number;
  vacancyId: number;
  name: string;
  email: string;
  phoneNumber: string;
  dateApplied: Date;
  isFavorite: boolean;
  isInterested: boolean | null;
  isHired: boolean;
  isBlocked: boolean;
  profileImgUrl: string;
  notes: VacancyApplicantNoteDto[];
}

export interface VacancyApplicantNoteDto {
  id: number;
  note: string;
  userId: number;
  creatorId: number;
  creatorName: string;
  dateCreated: Date;
}

export interface VacancyDetailsDto {
  id: number;
  signingBonus: number | null;
  estimatedSalary: number | null;
  estimatedSalaryMax: number | null;
  estimatedSalaryMin: number | null;
  estimatedSalaryHourly: number | null;
  position: string;
  jobType: string;
  description: string;
  address1: string;
  address2: string | null;
  city: string;
  state: string;
  zipCode: string;
  schedules: string[];
  supplementalPays: string[];
  benefits: string[];
  applicants: VacancyApplicantDto[];
}

export interface VacancyDto {
  id: number;
  officeId: number;
  status: VacancyStatus;
  blockCount: number;
  applicantCount: number;
  estimatedSalary: number | null;
  estimatedSalaryMax: number | null;
  estimatedSalaryMin: number | null;
  estimatedSalaryHourly: number | null;
  position: string;
  officeName: string;
  phone: string;
  jobType: string;
  schedule: string;
  address1: string;
  address2: string | null;
  city: string;
  state: string;
  zipCode: string;
  schedules: number[];
  supplementalPays: number[];
  benefits: number[];
  schedulerIds: number[];
}

export interface VacancyFormDataDto {
  positions: SelectListOption[];
  schedules: SelectListOption[];
  jobTypes: SelectListOption[];
  supplementalPays: SelectListOption[];
  benefits: SelectListOption[];
  estimatedSalaries: SelectListOption[];
  schedulers: SelectListOption[];
}

export class VacancyFormDto {
  id: number | null = null;
  officeId = 0;
  position = 0;
  jobType = 0;
  signingBonus: number | null = null;
  estimatedSalary: number | null = null;
  estimatedSalaryMax: number | null = null;
  estimatedSalaryMin: number | null = null;
  estimatedSalaryHourly: number | null = null;
  description = "";
  isAnonymous = false;
  schedules: number[] = [];
  supplementalPays: number[] = [];
  benefits: number[] = [];
  schedulerIds: number[] | null = null;
}

export class VacancyApplicantNoteFormDto {
  id: number | null = null;
  userId = 0;
  value = "";
}